/**
 * Shared constants for contract-import-job-related API calls.
 */

// Job lifecycle (see OEO-744): `in_progress` -> `ready` | `failed`, plus the
// internal-only `done` status once a contract has been created from the job.
// The API schema types `status` as a plain string with no enum, but this is
// the confirmed exhaustive set of values the backend sends, so it is also
// used to validate the wire response (see `zodContractImportJobSummarySchema`).
export const CONTRACT_IMPORT_JOB_STATUS = [
  'in_progress',
  'ready',
  'failed',
  'done',
] as const;

// Backend's `AVAILABLE_ACTIONS` map (status -> allowed actions):
// `ready` -> create_contract, delete; `failed` -> delete (see OEO-1252: the
// manual retry action was removed — failed jobs are retried automatically,
// server-side, only); `in_progress`/`done` -> none. This is the full set of
// values that can appear in `availableActions`, so it is validated as an
// enum, not a permissive string.
export const CONTRACT_IMPORT_JOB_ACTION = [
  'create_contract',
  'delete',
] as const;

// Backend's `ContractImportJobErrorType` enum, the exhaustive set of values
// `failureType` can take.
export const CONTRACT_IMPORT_JOB_FAILURE_TYPE = [
  'ocr_error',
  'timeout',
  'unreadable_file',
  'no_data_extracted',
  'enqueue_error',
] as const;

// Matches the API's per-file limit; shared between the create-jobs payload
// schema and the client-side Uppy restrictions so they cannot drift apart.
export const CONTRACT_IMPORT_MAX_FILE_SIZE_BYTES = 52_428_800; // 50 MB

// Matches the API's max jobs per bulk-create request; shared between the
// payload schema and the client-side Uppy restrictions.
export const CONTRACT_IMPORT_MAX_FILES = 10;
